// Lightweight pub/sub bridging the resilient Firestore listeners and the global
// ConnectionWatcher banner. A listener that can't self-heal a stale-token error
// flags "reconnect needed"; a successful (re)subscribe clears it. navigator.onLine
// is unreliable for real connectivity (a DNS blip can leave it `true`), so this
// Firestore-driven signal is the primary trigger for the banner.
let needsReconnect = false;
const subscribers = new Set();

export function flagReconnectNeeded(value = true) {
  if (needsReconnect === value) return;
  needsReconnect = value;
  subscribers.forEach((fn) => fn(needsReconnect));
}

export function subscribeReconnect(fn) {
  subscribers.add(fn);
  fn(needsReconnect); // push current state immediately
  return () => subscribers.delete(fn);
}
